// src/theme/components/progress.js
import { progressAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, defineStyle } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(progressAnatomy.keys);

// AI Temalı Varsayılan Progress Stili
const baseStyle = definePartsStyle((props) => {
  const { colorScheme: c, value, isIndeterminate } = props;

  // Track stili (ilerleme çubuğunun arka planı)
  const trackStyle = defineStyle({
    bg: "bgTertiary", // semantic token (veya borderPrimary)
    borderRadius: "full", // Tamamen yuvarlak köşeler
    boxShadow: "inner", // Hafif bir iç gölge
  });

  // FilledTrack stili (ilerleme çubuğunun dolan kısmı)
  const filledTrackStyle = defineStyle({
    // Ana marka rengini veya colorScheme'i kullan
    bg: c ? `${c}.${props.colorMode === 'dark' ? 300 : 500}` : "accent", // semantic token
    borderRadius: "full",
    transitionProperty: "common",
    transitionDuration: isIndeterminate ? "1s" : "var(--motion-duration-base)",
    transitionTimingFunction: "var(--motion-ease-apple)",
    ...(isIndeterminate && { // Belirsiz (indeterminate) durum için animasyonlar
      backgroundImage: `linear-gradient(
        to right,
        transparent 0%,
        var(--chakra-colors-${c ? `${c}-${props.colorMode === 'dark' ? 300 : 500}` : 'accent'}) 50%,
        transparent 100%
      )`,
      backgroundSize: "200% 100%",
      animation: "progressStripe 1s linear infinite",
    }),
    // İsteğe bağlı: Hafif bir gradyan
    // backgroundImage: `linear-gradient(to right, var(--chakra-colors-${c ? c : 'brand'}-400), var(--chakra-colors-${c ? c : 'brand'}-600))`,
  });

  return {
    track: trackStyle,
    filledTrack: filledTrackStyle,
    // Label stili (ilerleme yüzdesini gösteren metin)
    label: {
      color: "textPrimary", // semantic token
      fontWeight: "medium",
      fontSize: "sm",
    },
  };
});

// @keyframes animasyonu styles.js içinde global olarak tanımlanabilir,
// veya burada string olarak eklenebilir. Global daha iyi.
// styles.js içine:
// @keyframes progressStripe {
//   0% { background-position: 200% 0; }
//   100% { background-position: -200% 0; }
// }

export const progressTheme = defineMultiStyleConfig({
  baseStyle,
  // Farklı boyutlar (xs, sm, md, lg) için stiller de eklenebilir.
  sizes: {
    xs: definePartsStyle({ track: { h: "0.25rem" } }), // 4px
    sm: definePartsStyle({ track: { h: "0.375rem" } }), // 6px
    md: definePartsStyle({ track: { h: "0.5rem" } }),   // 8px (varsayılan olabilir)
    lg: definePartsStyle({ track: { h: "0.75rem" } }), // 12px
  },
  defaultProps: {
    colorScheme: "brand", // Varsayılan renk şeması
    size: "md", // Varsayılan boyut
  },
});

export default progressTheme; // index.js'de Progress: progressTheme olarak kullanılacak
